import createReducer from 'lib/create-reducer'
import { constants } from './actions'
import saga from './sagas'

const defaultState = {
  stats: null,
  subjectCoverage: null
}

const search = createReducer(defaultState, {
  [constants.FETCH_STATS_SUCCESS]: (state, stats) => ({
    ...state,
    stats
  }),
  [constants.FETCH_SUBJECT_COVERAGE_SUCCESS]: (state, subjectCoverage) => ({
    ...state,
    subjectCoverage
  })
}, saga)

export default search
